import { useState } from "react";

const PASSWORD = "Hvaler";
const STORAGE_KEY = "ca_wedding_access";

const BG_IMG =
  "https://customer-assets.emergentagent.com/job_admiring-jepsen-11/artifacts/e6eilwtd_Bilde%20Hvaler.png";

const hasAccess = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "granted";
  } catch {
    return false;
  }
};

export const PasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(hasAccess);
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim().toLowerCase() === PASSWORD.toLowerCase()) {
      try {
        sessionStorage.setItem(STORAGE_KEY, "granted");
      } catch {
        /* ignore */
      }
      setUnlocked(true);
    } else {
      setError(true);
      setValue("");
    }
  };

  if (unlocked) return children;

  return (
    <div
      data-testid="password-gate"
      className="min-h-screen relative flex items-center justify-center px-6 overflow-hidden"
    >
      {/* Soft blurred background */}
      <div className="absolute inset-0">
        <img
          src={BG_IMG}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover blur-md scale-110"
        />
        <div className="absolute inset-0 bg-[#F3F5E7]/55" />
      </div>

      <div className="relative z-10 w-full max-w-md text-center fade-in">
        <p
          data-testid="gate-eyebrow"
          className="text-[10px] uppercase tracking-[0.45em] text-[#68919B] mb-4 font-medium"
        >
          Velkommen
        </p>

        <h1 className="font-serif text-5xl md:text-6xl text-[#3D5E68] font-light leading-[1]">
          Celine
          <span className="font-script text-6xl md:text-7xl text-[#68919B] mx-2">
            &amp;
          </span>
          Aleksander
        </h1>

        <p className="mt-6 text-[#5A7682] font-light leading-relaxed">
          Vi gleder oss til å feire med dere på Hvaler.
          <br />
          Skriv inn passordet du fikk i invitasjonen.
        </p>

        <form
          onSubmit={handleSubmit}
          data-testid="gate-form"
          className="mt-12 space-y-6"
        >
          <div>
            <label
              htmlFor="gate-password"
              className="block text-[10px] uppercase tracking-[0.3em] text-[#68919B] mb-3 text-left"
            >
              Passord
            </label>
            <input
              id="gate-password"
              type="password"
              autoFocus
              autoComplete="off"
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                if (error) setError(false);
              }}
              data-testid="gate-password-input"
              className={`w-full bg-transparent border-b py-3 text-center text-lg text-[#3D5E68] focus:outline-none transition-colors font-light tracking-wider ${
                error
                  ? "border-[#68919B]"
                  : "border-[#68919B]/40 focus:border-[#3D5E68]"
              }`}
            />
            {error && (
              <p
                data-testid="gate-error"
                className="mt-3 text-xs text-[#68919B] font-light tracking-wide"
              >
                Feil passord — prøv igjen.
              </p>
            )}
          </div>

          <button
            type="submit"
            data-testid="gate-submit"
            className="w-full px-12 py-4 bg-[#68919B] text-[#F3F5E7] text-xs uppercase tracking-[0.3em] hover:bg-[#3D5E68] transition-colors duration-500"
          >
            Lås opp
          </button>
        </form>

        <p className="mt-10 text-[11px] uppercase tracking-[0.3em] text-[#68919B]/70 font-light">
          15. august · Spjærøy
        </p>
      </div>
    </div>
  );
};

export default PasswordGate;
